(function () {
  var VIEW_OFFMODEL_TOGGLE_CLASS = 'es-view-toggle--off-model';
  var VIEW_OFFMODEL_TOGGLE_PAGE_CLASS = 'es-page--off-model';
  var PLAYER_OFFMODEL_TOGGLE_CLASS = 'es-character-container--off-model';

  function syncInfoState(panel, isOpen) {
    if (!panel) {
      return;
    }

    panel.classList.toggle('es-info-container--open', isOpen);
    panel.setAttribute('aria-hidden', String(!isOpen));

    document.querySelectorAll('[aria-controls="HeaderInfoPanel"]').forEach(function (control) {
      control.setAttribute('aria-expanded', String(isOpen));
    });
  }

  function syncViewState(isOffModel) {
    document.querySelectorAll('.es-page').forEach(function (page) {
      page.classList.toggle(VIEW_OFFMODEL_TOGGLE_PAGE_CLASS, isOffModel);
    });

    document.querySelectorAll('.es-view-toggle').forEach(function (toggle) {
      toggle.classList.toggle(VIEW_OFFMODEL_TOGGLE_CLASS, isOffModel);
      toggle.setAttribute('aria-pressed', String(isOffModel));
    });

    document.querySelectorAll('.es-character-container').forEach(function (container) {
      container.classList.toggle(PLAYER_OFFMODEL_TOGGLE_CLASS, isOffModel);
    });
  }

  function initViewToggle() {
    var viewToggles = document.querySelectorAll('.js-toggle-view');
    var offModelButtons = document.querySelectorAll('.js-view-toggle-off-model');
    var onModelButtons = document.querySelectorAll('.js-view-toggle-on-model');

    if (!viewToggles.length && !offModelButtons.length && !onModelButtons.length) {
      return;
    }

    viewToggles.forEach(function (toggle) {
      toggle.addEventListener('click', function (event) {
        event.preventDefault();
        var isOffModel = !toggle.classList.contains(VIEW_OFFMODEL_TOGGLE_CLASS);
        syncViewState(isOffModel);
      });
    });

    offModelButtons.forEach(function (button) {
      button.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        syncViewState(true);
      });
    });

    onModelButtons.forEach(function (button) {
      button.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        syncViewState(false);
      });
    });
  }

  function initHeaderInfoDebug() {
    var panel = document.getElementById('HeaderInfoPanel');
    var desktopToggle = document.querySelector('.es-button-info__desktop');
    var mobileToggle = document.querySelector('.es-header--mobile .js-toggle-info');
    var closeToggle = document.querySelector('#HeaderInfoPanel .es-info-close');

    if (!panel || !desktopToggle) {
      return;
    }

    desktopToggle.addEventListener('click', function (event) {
      event.preventDefault();
      var nextState = !panel.classList.contains('es-info-container--open');
      syncInfoState(panel, nextState);
    });

    if (mobileToggle) {
      mobileToggle.addEventListener('click', function (event) {
        event.preventDefault();
        var nextState = !panel.classList.contains('es-info-container--open');
        syncInfoState(panel, nextState);
      });
    }

    if (closeToggle) {
      closeToggle.addEventListener('click', function (event) {
        event.preventDefault();
        syncInfoState(panel, false);
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initHeaderInfoDebug();
      initViewToggle();
    });
  } else {
    initHeaderInfoDebug();
    initViewToggle();
  }
})();
